import script from "./FontAwesome.vue?vue&type=script&setup=true&lang=js"
export * from "./FontAwesome.vue?vue&type=script&setup=true&lang=js"

import "./FontAwesome.vue?vue&type=style&index=0&id=17153572&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2025.48.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17153572"]])

export default __exports__